import { appointmentCardTheme, appointmentCardTypes } from './config';

const { RED, BLUE, GREEN, GRAY } = appointmentCardTheme;
const { DEFAULT,
  NO_SHOW_VISIT_OVERDUE,
  NOT_SCHEDULED,
  VISIT_OVERDUE,
  CONFIRMATION,
  CONFIRMED_BY_CLINIC,
  COMPLETED,
  NO_SHOW,
  SCHEDULED,
  OVERDUE } = appointmentCardTypes;

export const pastCardConfig = {
  CONFIRMED_BY_CLINIC: {
    cardType: CONFIRMED_BY_CLINIC,
    showTime: true,
    showWarning: true,
    primaryButtonText: 'yes',
    secondaryButtonText: 'no',
    theme: BLUE,
    secondaryButtonLabelColor: '#282829',
    isNoShow: false,
    showVisitInfo: true
  },
  COMPLETED: {
    cardType: COMPLETED,
    theme: GREEN,
    showTime: true,
    showClinic: true
  },
  NO_SHOW: {
    cardType: NO_SHOW,
    theme: GRAY,
    alertMessage: 'no_show',
    showTime: true,
    isNoShow: true
  },
  NO_SHOW_RESCHEDULED: {
    cardType: NO_SHOW,
    theme: GRAY,
    alertMessage: 'no_show',
    showTime: true,
    isNoShow: true
  }
};

export const scheduledCardConfig = {
  SCHEDULED: {
    cardType: SCHEDULED,
    theme: GREEN,
    showTime: true,
    showClinic: true,
    secondaryButtonText: 'reschedule',
    secondaryButtonLabelColor: '#DC334B'
  },
  CONFIRMATION: {
    cardType: CONFIRMATION,
    theme: GREEN,
    showTime: true,
    showClinic: true,
    primaryButtonText: 'confirm',
    secondaryButtonText: 'reschedule',
    secondaryButtonLabelColor: '#DC334B'
  }
};

export const expectdCardConfig = {
  DEFAULT: {
    cardType: DEFAULT,
    primaryButtonText: 'book_now',
    theme: BLUE
  },
  NOT_SCHEDULED: {
    cardType: NOT_SCHEDULED,
    primaryButtonText: 'book_now',
    theme: RED
  },
  OVERDUE: {
    cardType: OVERDUE,
    primaryButtonText: 'book_now',
    theme: RED,
    showSuggestedDate: false
  },
  VISIT_OVERDUE: {
    cardType: VISIT_OVERDUE,
    primaryButtonText: 'book_now',
    theme: RED,
    alertMessage: 'visit_overdue',
    showSuggestedDate: false
  },
  NO_SHOW_VISIT_OVERDUE: {
    cardType: NO_SHOW_VISIT_OVERDUE,
    primaryButtonText: 'book_now',
    theme: RED,
    alertMessage: 'visit_overdue'
  }
};

export const visitInfoConfig = {
  NOT_SCHEDULED: {
    className: 'f-14 f-regular f-amaranth visit-info m-16',
    translationKey: 'visit_your_dentist'
  },
  VISIT_OVERDUE: {
    className: 'f-14 f-regular f-amaranth visit-info m-16',
    translationKey: 'your_dentist_misses'
  },
  NO_SHOW_VISIT_OVERDUE: {
    className: 'f-14 f-regular f-amaranth visit-info m-16',
    translationKey: 'its_time_to'
  },
  CONFIRMED_BY_CLINIC: {
    className: 'f-14 f-regular f-comet visit-info m-16',
    translationKey: 'did_you_make'
  },
  default: {
    className: 'f-14 f-regular f-comet visit-info m-16',
    translationKey: 'visit_your_dentist_before'
  }
};
